import React from "react";
import ProductCardSkeleton from "../common/ProductCard/ProductCardSkeleton";

interface ProductsGridSkeletonProps {
  count?: number;
}

const ProductsGridSkeleton: React.FC<ProductsGridSkeletonProps> = ({
  count = 12,
}) => {
  return (
    <div className="products-grid">
      {Array.from({ length: count }).map((_, index) => (
        <ProductCardSkeleton key={index} />
      ))}
    </div>
  );
};

export default ProductsGridSkeleton;
